var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('h1',[_vm._v("This is an profile page")]),_c('ul',[_c('li',[_c('small',[_vm._v(_vm._s(_vm.$cryptr.user.sub))])]),_c('li',[_vm._v(_vm._s(_vm.$cryptr.user.email))])])])}
var staticRenderFns = []

export { render, staticRenderFns }